export const isConsole = () => {
  const host = window.location.hostname;
  const params = new URLSearchParams(window.location.search);

  // Query param override for local dev
  if (params.get('audience') === '1') return false;
  if (params.get('console') === '1') return true;

  // Console domains
  if (host.startsWith('console.')) return true;

  // Localhost defaults to console for dev
  if (host === 'localhost' || host === '127.0.0.1') return true;

  // Everything else is audience
  return false;
};
